import { useState, useEffect } from 'react'
import SummaryColumn from 'modules/Station/components/SummaryColumn/SummaryColumn'
import { ReactComponent as EnergySegmentsIcon } from 'icons/centipede-energy-segment.svg'
import BinaryBarChart from 'components/Charts/BinaryBarChart/BinaryBarChart'
import useOutdoorEnvironmentQuery from 'api/useQueryHooks/useOutdoorEnvironmentQuery'
import { checkNullRoundValue } from 'modules/Station/components/Tables/tableUtils'
import { filterSensorsSummary } from 'utils/sensors-utils'

const EnergySegmentsSummary = ({ data }) => {
  const { data: outdoorData, isLoading: isLoadingOutdoorData } =
    useOutdoorEnvironmentQuery(!!data)

  const outdoorTemp = isLoadingOutdoorData
    ? 'Loading'
    : checkNullRoundValue(outdoorData.externalAirTemp, '° C')
  const outdoorHumidity = isLoadingOutdoorData
    ? 'Loading'
    : checkNullRoundValue(outdoorData.externalHumidity, '%')

  const environmentalSection = [
    {
      sectionTitle: 'ENVIRONMENT',
      rows: [
        {
          label: 'Air Temp',
          value: outdoorTemp.toLocaleString(),
        },
        {
          label: 'Humidity',
          value: outdoorHumidity.toLocaleString(),
        },
      ],
    },
  ]

  const [formattedSections, setFormattedSections] = useState([])

  useEffect(() => {
    setFormattedSections(filterSensorsSummary(data))
  }, [data])

  if (!data) return null

  const count = data.totalSegments
  const healthyCount = data.totalHealthySegments
  const unhealthyCount = count - healthyCount

  const summaryMap = {
    title: `Energy Segments`,
    titleIcon: <EnergySegmentsIcon />,
    titleChart: (
      <BinaryBarChart
        positiveCount={healthyCount}
        negativeCount={unhealthyCount}
        tooltip={`Healthy Centipedes: ${healthyCount} | Unhealthy Centipedes: ${unhealthyCount}`}
        id="centipedeLineupsHealth"
      />
    ),
    sections: environmentalSection.concat(formattedSections),
  }

  return <SummaryColumn summaryMap={summaryMap} />
}

export default EnergySegmentsSummary
